// Pure motion policy (arch doc §8.1/D5). The ONLY legal way to decide animation.
// Most-restrictive-wins: the OS prefers-reduced-motion is a NON-OVERRIDABLE floor; the
// user's reducedMotion 'on' or mode 'Minimal' also force reduced; 'off'/'system' add no
// override and can never defeat the OS floor.
//
// Return shape is the object { reduce, animate } (consumed by FlowBar/ExperienceProvider).
// The BACKEND resolve_motion_policy() returns the 'reduced'|'full' string; the two layers
// share the decision logic, not the return type (WAVE_2_SPEC §2.3). Wave 2 adds the
// reducedMotion/mode inputs; when they are undefined this is identical to Wave 1.
export function resolveMotionPolicy({ prefersReducedMotion, reducedMotion, mode } = {}) {
  const reduce = prefersReducedMotion === true || reducedMotion === 'on' || mode === 'Minimal';
  return { reduce, animate: !reduce };
}
